import { config } from '@/config';
import { type RequestParameters, type Variables, Observable, type GraphQLResponse } from 'relay-runtime';

export const fetchFn = (operation: RequestParameters, variables: Variables) => {
  const observable = Observable.create<unknown>((sink: any) => {
    if (!operation.text) {
      sink.error(new Error('Operation text cannot be empty'));

      return;
    }

    if (!config.GRAPHQL_URL) {
      sink.error(new Error('GraphQL URL is not configured'));

      return;
    }

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    const token = localStorage.getItem('pix2bit:token');

    if (token) {
      headers['Authorization'] = token;
    }

    fetch(config.GRAPHQL_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        operationName: operation.name,
        query: operation.text,
        variables,
      }),
      credentials: 'include',
    })
      .then((response) => {
        if (response.status === 401 && !location.pathname.startsWith('/register') && !location.pathname.startsWith('/forgot-password') && !location.pathname.startsWith('/reset-password')) {
          localStorage.removeItem('pix2bit:token');
          sink.complete();

          return Promise.resolve({
            data: null,
            errors: [],
          });
        }
        return response.json();
      })
      .then((result) => {
        if (result) {
          sink.next(result);
          sink.complete();
        }
      })
      .catch((error) => {
        sink.error(error);
      });
  }) as Observable<GraphQLResponse>;

  return observable.map((result: any) => {
    if ('errors' in result) {
      const [error] = result.errors || [];

      if (error) {
        throw new Error(error.message);
      }
    }

    return result;
  });
};
